/**
 * @fileoverview Review request details query hook.
 * @description Wraps GET /approvals/{approvalRequestId} in a TanStack query, so a decision dialog
 * shows — and then sends — the request's current `approvalVersion`.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useQuery } from '@tanstack/react-query'

import { SALES_CRM_QUERY_KEYS } from '@/features/sales/constants/prospects-query-keys.constants'
import { getApprovalRequest } from '@/features/sales/services/approvals.service'

/**
 * @description Fetches one review request in full.
 * @param {string} approvalRequestId - The request.
 * @returns {ReturnType<typeof useQuery>} The query (data is the request with its version).
 */
export function useApprovalRequest(approvalRequestId: string) {
  return useQuery({
    queryKey: SALES_CRM_QUERY_KEYS.approval(approvalRequestId),
    queryFn: () => getApprovalRequest(approvalRequestId),
  })
}
